import {lazy} from 'react'
import {Route, Switch} from 'react-router-dom'

export enum BusinessRoutesEnum {
    DashboardCompany = '/empresarial/painel',
    ShowOrder = '/empresarial/pedidos/:id',
    DatatableContracts = '/empresarial/contratos',
    DatatableInvoices = '/empresarial/faturas',
    ShowInvoice = '/empresarial/faturas/:id',
    DatatableBeneficiaries = '/empresarial/beneficiarios',
}

export default function BusinessRouter() {
    const DashboardCompany = lazy(() => import('../../pages/business/dashboard/DashboardCompany'))

    const DatatablePreCompany = lazy(
        () => import('../../pages/business/pre_companies/DatatablePreCompany')
    )
    const DatatableCompany = lazy(() => import('../../pages/business/companies/DatatableCompany'))
    const ProfileCompany = lazy(() => import('../../pages/business/companies/ProfileCompany'))
    const RegisterCompany = lazy(() => import('../../pages/business/companies/RegisterCompany'))

    const ShowOrder = lazy(() => import('../../pages/business/orders/ShowOrder'))
    const DatatablePaymentApproved = lazy(
        () => import('../../pages/business/orders/DatatableOrders')
    )
    const DatatablePaymentPending = lazy(
        () => import('../../pages/business/orders/DatatablePaymentPending')
    )

    const DatatableUsers = lazy(() => import('../../pages/business/users/DatatableUsers'))
    const ShowUser = lazy(() => import('../../pages/business/users/ShowUser'))

    const DatatableContracts = lazy(
        () => import('../../pages/business/contracts/DatatableContracts')
    )

    const DatatableInvoices = lazy(() => import('../../pages/business/invoices/DatatableInvoices'))
    const ShowInvoice = lazy(() => import('../../pages/business/invoices/ShowInvoice'))

    const DatatableBeneficiaries = lazy(
        () => import('../../pages/management/beneficiaries/BeneficiaryDatatable')
    )

    return (
        <Switch>
            <Route path={BusinessRoutesEnum.DashboardCompany} component={DashboardCompany} />

            <Route path='/empresarial/empresas/cadastro' component={RegisterCompany} />
            <Route path='/empresarial/empresas/:id' component={ProfileCompany} />
            <Route path='/empresarial/empresas' component={DatatableCompany} />
            <Route path='/empresarial/pre-empresas' component={DatatablePreCompany} />

            <Route path='/empresarial/pedidos/pendentes' component={DatatablePaymentPending} />
            <Route path='/empresarial/pedidos/listagem' component={DatatablePaymentApproved} />
            <Route path='/empresarial/pedidos/:id' component={ShowOrder} />

            <Route path='/empresarial/usuarios/:cpf' component={ShowUser} />
            <Route path='/empresarial/usuarios' component={DatatableUsers} />

            <Route path={BusinessRoutesEnum.DatatableContracts} component={DatatableContracts} />

            <Route path={BusinessRoutesEnum.ShowInvoice} component={ShowInvoice} />
            <Route path={BusinessRoutesEnum.DatatableInvoices} component={DatatableInvoices} />

            <Route
                path={BusinessRoutesEnum.DatatableBeneficiaries}
                component={DatatableBeneficiaries}
            />
        </Switch>
    )
}
